/**
 * Overview | Files tabs on the project pages (ViewPage and SharedViewPage).
 *
 * The project page is one very long scroll — tradies, needing attention,
 * expired requests, expiring files — and the project's own documents used to
 * sit at the bottom of it, thousands of pixels down. The Files tab puts them
 * one click away instead.
 *
 * The tab lives in the URL (`?tab=files`) so it survives a refresh, can be
 * bookmarked, and can be linked to — the expiry notification opens the project
 * straight on the Files tab.
 *
 * The host page must provide `canViewProjectFiles` (a computed). A user who
 * can't view project files never gets the Files tab, even if the URL asks
 * for it. A page may also provide `canViewProjectJobs` to offer a Jobs tab
 * (`?tab=jobs`) with the same rule.
 */
const FILES = 'files'
const JOBS = 'jobs'
const OVERVIEW = 'overview'

function tabFromRoute(route) {
  const tab = route && route.query && route.query.tab
  return tab === FILES || tab === JOBS ? tab : OVERVIEW
}

export default {
  data() {
    return {
      activeTab: tabFromRoute(this.$route),
    }
  },

  computed: {
    showFilesTab() {
      return this.activeTab === FILES && !!this.canViewProjectFiles
    },

    // The Jobs tab is optional: only pages that provide `canViewProjectJobs`
    // (the owning company's project page) can ever show it.
    showJobsTab() {
      return this.activeTab === JOBS && !!this.canViewProjectJobs
    },

    showOverviewTab() {
      return !this.showFilesTab && !this.showJobsTab
    },
  },

  watch: {
    // Back/forward, or a notification link, changes the query while we're mounted.
    '$route.query.tab'() {
      this.activeTab = tabFromRoute(this.$route)
    },
  },

  methods: {
    setTab(tab) {
      this.activeTab = tab === FILES || tab === JOBS ? tab : OVERVIEW

      if (!this.$router || !this.$route) return
      const query = { ...this.$route.query }
      if (this.activeTab !== OVERVIEW) {
        query.tab = this.activeTab
      } else {
        delete query.tab
      }
      // replace, not push: flipping tabs shouldn't fill the back-button history.
      this.$router.replace({ query }).catch(() => {})
    },
  },
}
